<template>
    <div>
        <nav class="navbar navbar-expand-lg fixed-top navbar-dark bg-dark justify-content-between">
            <a class="navbar-brand" href="#">Frontex Admin</a>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarNavDropdown">
                <ul class="navbar-nav">
                    <li class="nav-item" :class="currentPage === 'index' ? 'active' : ''">
                        <router-link class="nav-link" to="/admin/">Home</router-link>
                    </li>
                    <li class="nav-item" :class="currentPage === 'indicators' ? 'active' : ''">
                        <router-link class="nav-link" to="/admin/indicators">Indicator observations</router-link>
                    </li>
                    <li class="nav-item" :class="currentPage === 'sessions' ? 'active' : ''">
                        <router-link class="nav-link" to="/admin/sessions">Sessions</router-link>
                    </li>
                </ul>
            </div>
        </nav>
        <div class="container page-container">
            <transition name="slideLeft">
                <div class="container">
                    <component :is="currentComponent" class="page-component"></component>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    import * as MutationTypes from '@/store/mutation-types';
    import FrontpageView from '@/views/admin/pages/frontpage'
    import IndicatorsView from '@/views/admin/pages/indicators'
    import SessionsView from '@/views/admin/pages/sessions'
    import ScenariosView from '@/views/admin/pages/scenarios'
    import Config from '@/config';

    const pageComponents = {
        'index': FrontpageView,
        'indicators': IndicatorsView,
        'sessions': SessionsView,
        'scenarios': ScenariosView,
    };

    export default {
        name: 'admin-controller',
        beforeMount() {
            this.$apiClient.setBaseUrl(Config.baseApiUrl);

            this.$store.commit(MutationTypes.SET_CURRENT_APP_SEGMENT, 'admin');
            this.$store.commit(MutationTypes.SET_CURRENT_BACKGROUND, null);
        },
        computed: {
            currentPage() {
                return this.$route.params.page || 'index';
            },
            currentComponent() {
                return pageComponents[this.currentPage];
            },
        }
    }
</script>

<style lang="scss">
    @import "../../../node_modules/vue-notifyjs/themes/default.css";
</style>

<style lang="scss" scoped>
    .page-container {
        position: relative;
        padding-top: 70px;
    }

    .page {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
    }
</style>